import { Injectable } from '@angular/core';

@Injectable()
export class RichTextEditorProvider {
	providedText: any = '';

	constructor() {
		console.log('Hello RichTextEditorProvider Provider');
	}

	setText(text){
		this.providedText = text;
	}
}



// WEBPACK FOOTER //
// ./src/providers/rich-text-editor.ts